import ReactPlayer from 'react-player/youtube';
import { styled } from 'styled-components';

interface VideoProps extends React.ComponentPropsWithoutRef<'div'> {
  link: string;
  playing?: boolean;
  onPauseOrEnded: () => void;
  className?: string;
}

export const extractYoutubeVideoId = (link: string): string | undefined => {
  // eslint-disable-next-line prefer-named-capture-group -- This is a known issue with the current version of eslint
  const regExp = /^.*(youtu.*be.*)\/(watch\?v=|embed\/|shorts|)(.*?((?=[&#?])|$)).*/;
  let youtubeVideoId = regExp.exec(link)?.[3];

  if (youtubeVideoId === '') {
    youtubeVideoId = undefined;
  }

  return youtubeVideoId;
};

export const Video = ({ link, playing, onPauseOrEnded, className }: VideoProps) => {
  const youtubeVideoId = extractYoutubeVideoId(link);

  return (
    <Container className={className}>
      <ReactPlayer
        url={`https://www.youtube.com/embed/${youtubeVideoId}`}
        config={{
          playerVars: {
            showinfo: 0,
            rel: 0,
          },
        }}
        playing={playing}
        controls
        stopOnUnmount
        onPause={onPauseOrEnded}
        onEnded={onPauseOrEnded}
        width="100%"
        height="100%"
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
`;
